// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/finance/wallet.proto" (package "mlmbox.client.finance", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Wallet as Wallet$ } from "./wallet.ts";
import type { Wallet_Processing_Asset_WithdrawalAddressHistory } from "../../types/wallet.ts";
import type { Wallet_Processing_Asset_Id } from "../../types/wallet.ts";
import type { WalletWithdrawalRequest } from "./wallet.ts";
import type { WalletValidateAddressResponse } from "./wallet.ts";
import type { WalletValidateAddressRequest } from "./wallet.ts";
import type { WalletDepositAddressResponse } from "./wallet.ts";
import type { TransferRequest } from "./wallet.ts";
import type { Wallet_Processing_List } from "../../types/wallet.ts";
import type { Wallet_Processing } from "../../types/wallet.ts";
import type { Wallet_Processing_Id } from "../../types/wallet.ts";
import type { Wallet_Asset_WithdrawalCapacity } from "../../types/wallet.ts";
import type { Asset_Id } from "../../types/asset.ts";
import type { Wallet_Asset_Transaction_List } from "../../types/wallet.ts";
import type { WalletAssetTransactionListRequest } from "./wallet.ts";
import type { Wallet_Asset_Transaction } from "../../types/wallet.ts";
import type { Wallet_Asset_Transaction_Id } from "../../types/wallet.ts";
import type { Wallet_Asset_List } from "../../types/wallet.ts";
import type { Wallet_Asset } from "../../types/wallet.ts";
import type { WalletAssetGetRequest } from "./wallet.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Wallet } from "../../types/wallet.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.finance.Wallet
 */
export interface IWalletClient {
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Wallet);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Wallet>;
    /**
     * @generated from protobuf rpc: AssetGet(mlmbox.client.finance.WalletAssetGetRequest) returns (mlmbox.types.Wallet.Asset);
     */
    assetGet(input: WalletAssetGetRequest, options?: RpcOptions): UnaryCall<WalletAssetGetRequest, Wallet_Asset>;
    /**
     * @generated from protobuf rpc: AssetsAll(google.protobuf.Empty) returns (mlmbox.types.Wallet.Asset.List);
     */
    assetsAll(input: Empty, options?: RpcOptions): UnaryCall<Empty, Wallet_Asset_List>;
    /**
     * @generated from protobuf rpc: AssetTransactionGet(mlmbox.types.Wallet.Asset.Transaction.Id) returns (mlmbox.types.Wallet.Asset.Transaction);
     */
    assetTransactionGet(input: Wallet_Asset_Transaction_Id, options?: RpcOptions): UnaryCall<Wallet_Asset_Transaction_Id, Wallet_Asset_Transaction>;
    /**
     * @generated from protobuf rpc: AssetTransactionList(mlmbox.client.finance.WalletAssetTransactionListRequest) returns (mlmbox.types.Wallet.Asset.Transaction.List);
     */
    assetTransactionList(input: WalletAssetTransactionListRequest, options?: RpcOptions): UnaryCall<WalletAssetTransactionListRequest, Wallet_Asset_Transaction_List>;
    /**
     * @generated from protobuf rpc: AssetWithdrawalCapacityGet(mlmbox.types.Asset.Id) returns (mlmbox.types.Wallet.Asset.WithdrawalCapacity);
     */
    assetWithdrawalCapacityGet(input: Asset_Id, options?: RpcOptions): UnaryCall<Asset_Id, Wallet_Asset_WithdrawalCapacity>;
    /**
     * @generated from protobuf rpc: ProcessingsGet(mlmbox.types.Wallet.Processing.Id) returns (mlmbox.types.Wallet.Processing);
     */
    processingsGet(input: Wallet_Processing_Id, options?: RpcOptions): UnaryCall<Wallet_Processing_Id, Wallet_Processing>;
    /**
     * @generated from protobuf rpc: ProcessingsAll(google.protobuf.Empty) returns (mlmbox.types.Wallet.Processing.List);
     */
    processingsAll(input: Empty, options?: RpcOptions): UnaryCall<Empty, Wallet_Processing_List>;
    /**
     * @generated from protobuf rpc: Transfer(mlmbox.client.finance.TransferRequest) returns (mlmbox.types.Wallet.Asset.Transaction);
     */
    transfer(input: TransferRequest, options?: RpcOptions): UnaryCall<TransferRequest, Wallet_Asset_Transaction>;
    /**
     * @generated from protobuf rpc: DepositAddress(mlmbox.types.Wallet.Processing.Id) returns (mlmbox.client.finance.WalletDepositAddressResponse);
     */
    depositAddress(input: Wallet_Processing_Id, options?: RpcOptions): UnaryCall<Wallet_Processing_Id, WalletDepositAddressResponse>;
    /**
     * @generated from protobuf rpc: ValidateAddress(mlmbox.client.finance.WalletValidateAddressRequest) returns (mlmbox.client.finance.WalletValidateAddressResponse);
     */
    validateAddress(input: WalletValidateAddressRequest, options?: RpcOptions): UnaryCall<WalletValidateAddressRequest, WalletValidateAddressResponse>;
    /**
     * @generated from protobuf rpc: Withdrawal(mlmbox.client.finance.WalletWithdrawalRequest) returns (mlmbox.types.Wallet.Asset.Transaction);
     */
    withdrawal(input: WalletWithdrawalRequest, options?: RpcOptions): UnaryCall<WalletWithdrawalRequest, Wallet_Asset_Transaction>;
    /**
     * @generated from protobuf rpc: WithdrawalAddressHistory(mlmbox.types.Wallet.Processing.Asset.Id) returns (mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory);
     */
    withdrawalAddressHistory(input: Wallet_Processing_Asset_Id, options?: RpcOptions): UnaryCall<Wallet_Processing_Asset_Id, Wallet_Processing_Asset_WithdrawalAddressHistory>;
}
/**
 * @generated from protobuf service mlmbox.client.finance.Wallet
 */
export class WalletClient implements IWalletClient, ServiceInfo {
    typeName = Wallet$.typeName;
    methods = Wallet$.methods;
    options = Wallet$.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Wallet);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Wallet> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Wallet>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AssetGet(mlmbox.client.finance.WalletAssetGetRequest) returns (mlmbox.types.Wallet.Asset);
     */
    assetGet(input: WalletAssetGetRequest, options?: RpcOptions): UnaryCall<WalletAssetGetRequest, Wallet_Asset> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<WalletAssetGetRequest, Wallet_Asset>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AssetsAll(google.protobuf.Empty) returns (mlmbox.types.Wallet.Asset.List);
     */
    assetsAll(input: Empty, options?: RpcOptions): UnaryCall<Empty, Wallet_Asset_List> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Wallet_Asset_List>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AssetTransactionGet(mlmbox.types.Wallet.Asset.Transaction.Id) returns (mlmbox.types.Wallet.Asset.Transaction);
     */
    assetTransactionGet(input: Wallet_Asset_Transaction_Id, options?: RpcOptions): UnaryCall<Wallet_Asset_Transaction_Id, Wallet_Asset_Transaction> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<Wallet_Asset_Transaction_Id, Wallet_Asset_Transaction>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AssetTransactionList(mlmbox.client.finance.WalletAssetTransactionListRequest) returns (mlmbox.types.Wallet.Asset.Transaction.List);
     */
    assetTransactionList(input: WalletAssetTransactionListRequest, options?: RpcOptions): UnaryCall<WalletAssetTransactionListRequest, Wallet_Asset_Transaction_List> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<WalletAssetTransactionListRequest, Wallet_Asset_Transaction_List>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AssetWithdrawalCapacityGet(mlmbox.types.Asset.Id) returns (mlmbox.types.Wallet.Asset.WithdrawalCapacity);
     */
    assetWithdrawalCapacityGet(input: Asset_Id, options?: RpcOptions): UnaryCall<Asset_Id, Wallet_Asset_WithdrawalCapacity> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<Asset_Id, Wallet_Asset_WithdrawalCapacity>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ProcessingsGet(mlmbox.types.Wallet.Processing.Id) returns (mlmbox.types.Wallet.Processing);
     */
    processingsGet(input: Wallet_Processing_Id, options?: RpcOptions): UnaryCall<Wallet_Processing_Id, Wallet_Processing> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<Wallet_Processing_Id, Wallet_Processing>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ProcessingsAll(google.protobuf.Empty) returns (mlmbox.types.Wallet.Processing.List);
     */
    processingsAll(input: Empty, options?: RpcOptions): UnaryCall<Empty, Wallet_Processing_List> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Wallet_Processing_List>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Transfer(mlmbox.client.finance.TransferRequest) returns (mlmbox.types.Wallet.Asset.Transaction);
     */
    transfer(input: TransferRequest, options?: RpcOptions): UnaryCall<TransferRequest, Wallet_Asset_Transaction> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<TransferRequest, Wallet_Asset_Transaction>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DepositAddress(mlmbox.types.Wallet.Processing.Id) returns (mlmbox.client.finance.WalletDepositAddressResponse);
     */
    depositAddress(input: Wallet_Processing_Id, options?: RpcOptions): UnaryCall<Wallet_Processing_Id, WalletDepositAddressResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<Wallet_Processing_Id, WalletDepositAddressResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ValidateAddress(mlmbox.client.finance.WalletValidateAddressRequest) returns (mlmbox.client.finance.WalletValidateAddressResponse);
     */
    validateAddress(input: WalletValidateAddressRequest, options?: RpcOptions): UnaryCall<WalletValidateAddressRequest, WalletValidateAddressResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<WalletValidateAddressRequest, WalletValidateAddressResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Withdrawal(mlmbox.client.finance.WalletWithdrawalRequest) returns (mlmbox.types.Wallet.Asset.Transaction);
     */
    withdrawal(input: WalletWithdrawalRequest, options?: RpcOptions): UnaryCall<WalletWithdrawalRequest, Wallet_Asset_Transaction> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<WalletWithdrawalRequest, Wallet_Asset_Transaction>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: WithdrawalAddressHistory(mlmbox.types.Wallet.Processing.Asset.Id) returns (mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory);
     */
    withdrawalAddressHistory(input: Wallet_Processing_Asset_Id, options?: RpcOptions): UnaryCall<Wallet_Processing_Asset_Id, Wallet_Processing_Asset_WithdrawalAddressHistory> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<Wallet_Processing_Asset_Id, Wallet_Processing_Asset_WithdrawalAddressHistory>("unary", this._transport, method, opt, input);
    }
}
